import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-role-admin-su-reactivate-staff-options",
	templateUrl: "./role-admin-su-reactivate-staff-options.component.html",
	styleUrls: ["./role-admin-su-reactivate-staff-options.component.css"],
})
export class RoleAdminSuReactivateStaffOptionsComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef) {}

	ngOnInit(): void {
		this.lstSelectedUsers = this.dialogConfig.data.lstSelectedUsers;

		console.log(this.lstSelectedUsers);

		this.TotalStaffCount = this.lstSelectedUsers.length;

		var lstImported = this.lstSelectedUsers.filter((user) => user.DefinedByID == 2);
		this.ImportedCount = lstImported.length;

		var lstLocked = this.lstSelectedUsers.filter((user) => user.Locked == true);
		this.LockedCount = lstLocked.length;
	}

	//////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////

	lstSelectedUsers: any = [];
	TotalStaffCount: number = 0;
	ImportedCount: number = 0;
	LockedCount: number = 0;
	ChangeDefinedBy: boolean = false;
	UnlockAccounts: boolean = false;

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////

	onReactivateStaff() {
		this.ref.close({
			ChangeDefinedBy: this.ChangeDefinedBy,
			UnlockAccounts: this.UnlockAccounts,
		});
	}

	onClose() {
		this.ref.close(0);
	}

	//////////////////////////////////////////////////////////////
}
